import * as React from "react";
import { InputAdornment, TextField } from "@mui/material";
import { observer } from "mobx-react";
import { useRootStore } from "../../../store/contexts";
import { SearchIcon } from "../../../icons";
export type SearchBoxProps = {
  value: string;
  onSearch: (value: string) => void;
  label?: string;
  id?: string;
  autoComplete?: string;
};

export const SearchBox: React.FC<SearchBoxProps> = observer(
  ({ label, value, onSearch, id, autoComplete }) => {
    const rootStore = useRootStore();
    const { prefStore, langStore } = rootStore;
    return (
      <TextField
        id={!id ? "search-field" : id}
        type={"search"}
        value={value}
        variant={"standard"}
        sx={{ marginTop: "0px" }}
        size={prefStore.toolbarSize}
        placeholder={!label ? langStore.searchCommand : label}
        autoComplete={autoComplete ? autoComplete : prefStore.autoComplete}
        onChange={(event) => onSearch(event.target.value)}
        InputProps={{
          autoFocus: value !== "",
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    );
  }
);
